import moment, { MomentInput } from 'moment';

/**
 * The UTC offset for Jakarta (WIB) in minutes.
 */
const JAKARTA_OFFSET = 7 * 60; // 7 hours in minutes

/**
 * The default date format used for formatting dates.
 */
export const DEFAULT_DATE_FORMAT = 'D MMMM YYYY';

/**
 * The default time format used for formatting times.
 */
export const DEFAULT_TIME_FORMAT = 'hh:mm:ss';

/**
 * The default date and time format used for formatting date-time values.
 */
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;

/**
 * Represents the current time in Jakarta timezone (WIB).
 */
export const jakartaTime = moment().utcOffset(JAKARTA_OFFSET);

/**
 * Formats a moment.js object representing a date-time value to the specified format in the local browser's timezone.
 *
 * @param value - The date-time value to format.
 * @param format - The format string used for formatting the date-time value. Defaults to DEFAULT_DATE_TIME_FORMAT.
 * @returns A formatted string representing the date-time value in the local browser's timezone.
 */
export const localBrowserTime = (
  value?: MomentInput,
  format = DEFAULT_DATE_TIME_FORMAT,
) => moment.utc(value).local().format(format);

/**
 * Checks if the current Jakarta time is between the provided start and end times.
 *
 * @param startTime - The start time in 'HH:mm' format.
 * @param endTime - The end time in 'HH:mm' format.
 * @returns True if the current Jakarta time is between the provided start and end times; otherwise, false.
 */
export const isBetweenJakartaTime = (startTime: string, endTime: string) => {
  // Create Moment.js objects for the provided start and end times
  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  // Check if the current time is between the start and end times
  return jakartaTime.isBetween(start, end, null, '[]');
};
